import '../../css/PopMessage.css'
import { useContext } from 'react';
import { IPopMessageContainerProps } from '../../interfaces/popMessageInterface'
import { AppContext } from '../context/AppContext';
import PopMessageDetailsDiv from './PopMessageDetailsDiv'

const PopMessageDetailsContainer = (props: IPopMessageContainerProps) => {
    const { assetNamesArr } = useContext(AppContext);
    const [assetNamesToDisplay]  = assetNamesArr;
   
    return (
        <div className='asset-details-data-container'>
            {props.type === "general" &&
                Object.entries(props.formData).map(([key,value]) => {
                    if(key && typeof(value) === "string" && key !== "profile" && key !== "state") {
                        return <PopMessageDetailsDiv divKey={assetNamesToDisplay[key]} value={value} />
                    }
                })
            }
            {props.type === "load-sensor" &&
                <>  
                    {(props.formData.loadSensorId && props.formData.assetName) &&
                    <>
                        <PopMessageDetailsDiv divKey={assetNamesToDisplay.loadSensorId} 
                            value={props.formData.loadSensorId}
                        /> 
                        <PopMessageDetailsDiv divKey={assetNamesToDisplay.assetName}
                         value={props.formData.assetName} 
                        />
                    </>      
                    }
                    <div className='asset-details-more-data'>more data:</div>
                    {props.loadSensorData && Object.entries(props.loadSensorData).map(([key,value]) => {
                        if(key && key !== "assetName") {
                            return <PopMessageDetailsDiv divKey={assetNamesToDisplay[key]} value={value} />  
                        }
                    })}
                </>

            }
        </div>
    );
};


export default PopMessageDetailsContainer;